// extracted by mini-css-extract-plugin
export default {"profil":"profil_profil__lN9iL","container_card":"profil_container_card__M1oNK","card":"profil_card__h+mbD","title":"profil_title__7+MQP"};